import React from "react";
import { ButtonProps } from "./Button.types";
import { ButtonWrapper } from "./Button.styles";
import { Heading5SemiboldTypography } from "../../primitives/Typography/typographyVariants";

export const Button = (props: ButtonProps) => {
  return (
    <ButtonWrapper {...props} data-cy={props.dataCy}>
      {props.leftIcon && <span className="left-icon">{props.leftIcon}</span>}
      <Heading5SemiboldTypography>{props.children}</Heading5SemiboldTypography>
      {props.rightIcon && <span className="right-icon">{props.rightIcon}</span>}
    </ButtonWrapper>
  );
};
